var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefundIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#919191"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 14V12.5333H10.575C11.3625 12.5333 12.047 12.2889 12.6285 11.8C13.21 11.3111 13.5005 10.7 13.5 9.96667C13.5 9.23333 13.2092 8.62222 12.6277 8.13333C12.0462 7.64444 11.362 7.4 10.575 7.4H5.85L7.8 9.30667L6.75 10.3333L3 6.66667L6.75 3L7.8 4.02667L5.85 5.93333H10.575C11.7875 5.93333 12.8283 6.31833 13.6973 7.08833C14.5663 7.85833 15.0005 8.81778 15 9.96667C15 11.1156 14.5655 12.075 13.6965 12.845C12.8275 13.615 11.787 14 10.575 14H5.25Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefundIcon);
export default __webpack_public_path__ + "static/media/refund-icon.a1eb278c0fff7685fea94387b1490590.svg";
export { ForwardRef as ReactComponent };